import React, { useCallback } from 'react';
import { HeaderWrapper, LogoWrapper, MoreWrapper, TitleWrapper, ScoreboardButtonWrapper } from './header.style';
import Image from '@mlb/react-patterns/v4/components/Image/image';
import Link from '@mlb/react-patterns/v4/components/Link/link';
import { useSelector } from 'react-redux';
import { getHeaderState } from '../store/selectors/getHeaderState';
import MediaLinksDataContainer from '@gameday/components/MediaLinks/MediaLinksDataContainer';
import COLORS from '@mlb/react-patterns/v4/style/universal.color.ts';
import TitleIcon from './TitleIcon';
import { AccordionIconTypeTypes, AccordionIconThemeTypes } from '@mlb/react-patterns/v4/components/AccordionItem/AccordionItem.types';
import Icon from '@mlb/react-patterns/v4/components/Icon/icon';
import PropTypes from 'prop-types';
import { useTheme } from '@gameday/utils/hooks/useTheme';
import { resourcePath } from '@gameday/utils/resource-path';

const {
    mlbBlack
} = COLORS;

const MLBHeader = ({
    onClick,
    sbVisibility,
    hasScoreboard,
    showGamedaySb,
    linkRef
}) => {
    const { language, headerInfo } = useSelector(getHeaderState);
    const theme = useTheme();

    const url = language === 'es' ? '/es' : '/';

    const { headerImg, headerUrl, headerAlt } = headerInfo;

    const img = resourcePath.get('headerLogo', {
        theme,
        id: headerImg
    });

    const gamedayOnClick = useCallback((e) => {
        e.preventDefault();
        onClick();
    }, [onClick]);

    return (
        <HeaderWrapper>
            <LogoWrapper>
                <Link url={headerUrl} ariaLabel={headerAlt}>
                    <Image
                        src={img}
                        className='header-logo'
                        lazyload
                        alt={headerAlt}
                    />
                </Link>
            </LogoWrapper>
            <TitleWrapper>
                <Link url={url} handlers={{ onClick: gamedayOnClick }} ariaLabel='gameday' ref={linkRef} aria-expanded={sbVisibility}><TitleIcon fill={mlbBlack} /></Link>
                { !showGamedaySb && hasScoreboard && <ScoreboardButtonWrapper
                    iconType={ AccordionIconTypeTypes.CIRCULAR }
                    iconTheme={ AccordionIconThemeTypes.LIGHT }
                    iconRotated={sbVisibility}
                    onClick={onClick}><Icon name={'arrow-expand'} fill={mlbBlack} width={12}/>
                </ScoreboardButtonWrapper> }
            </TitleWrapper>
            <MoreWrapper>
                <MediaLinksDataContainer />
            </MoreWrapper>
        </HeaderWrapper>
    );
};

MLBHeader.propTypes = {
    onClick: PropTypes.func,
    sbVisibility: PropTypes.bool,
    hasScoreboard: PropTypes.bool,
    showGamedaySb: PropTypes.bool
};

export default MLBHeader;
